import $ from 'jquery';

$('.tg__col').each(function(){
    $(this).on('click', function(){
        $('.tg__col').removeClass('tg__col--active');
        $(this).addClass('tg__col--active');
    });
});
if ($(window).width() < 760) {
    $('.footer__title').on('click tap', function(){
        $(this).toggleClass('active');
        $(this).next().slideToggle();
    });
}

$('.of__link').hover(function(){
    let off = $(this).data('of');
    
    $('.of__img').removeClass('active');
    $('.of__img.'+off+'').addClass('active');
});

$('.sm__menuli').hover(function(){
    let off = $(this).data('of');
    
    $('.mof__img').removeClass('active');
    $('.mof__img.'+off+'').addClass('active');
});